"use client";

import { useCallback } from "react";
import { track } from "../../core/client";

/**
 * 전략 히스토리 네비게이션 추적 훅
 */
export function useStrategyHistoryNav() {
    const trackNav = useCallback(
        (strategyId: string, direction: "prev" | "next") => {
            track("strategy_history_nav", {
                strategy_id: strategyId,
                direction,
            });
        },
        []
    );

    return { trackNav };
}

/**
 * 전략 차트 클릭 추적 훅
 */
export function useStrategyChartClick() {
    const trackClick = useCallback(
        (strategyId: string, range: string, metric?: string) => {
            track("strategy_chart_click", {
                strategy_id: strategyId,
                range,
                metric: metric || undefined,
            });
        },
        []
    );

    return { trackClick };
}

/**
 * 전략 관련 추적 훅 (통합)
 * @deprecated 개별 훅 사용을 권장합니다 (useStrategyHistoryNav, useStrategyChartClick)
 */
export function useStrategyTracking() {
    const trackHistoryNav = useCallback(
        (strategyId: string, direction: "prev" | "next") => {
            track("strategy_history_nav", {
                strategy_id: strategyId,
                direction,
            });
        },
        []
    );

    const trackChartClick = useCallback(
        (strategyId: string, range: string, metric?: string) => {
            track("strategy_chart_click", {
                strategy_id: strategyId,
                range,
                metric: metric || undefined,
            });
        },
        []
    );

    return {
        trackHistoryNav,
        trackChartClick,
    };
}

